import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import { MessageTitle } from 'store/admin/notifications/types';
import { setNotificationError, setNotificationSuccess } from 'store/admin/notifications/slice';

import { listFolders, triggerExport, deleteDump, downloadDump } from 'api/dumps';

import {
  requestFolders,
  getFoldersSuccess,
  getFoldersError,
  requestTrigger,
  triggerSuccess,
  triggerError,
  requestDelete,
  deleteSuccess,
  deleteError,
  requestDownload,
  downloadSuccess,
  downloadError,
  ExportFolder,
  KeyPayload,
  TriggerPayload,
} from './slice';

export function* foldersRequestSaga() {
  try {
    const response: AxiosResponse<ExportFolder[]> = yield call(listFolders, {});
    yield put(getFoldersSuccess(response.data));
  } catch (error: any) {
    const msg = error?.message || 'Failed to load export folders';
    yield put(getFoldersError(msg));
  }
}

export function* triggerRequestSaga({ payload }: { payload: TriggerPayload }) {
  try {
    yield call(triggerExport, payload);
    yield put(triggerSuccess(payload));
    yield put(setNotificationSuccess({ title: MessageTitle.crudSuccess }));

    yield put(requestFolders());
  } catch (error: any) {
    const msg = error?.message || 'Failed to trigger export';
    yield put(triggerError(msg));
  }
}

export function* deleteRequestSaga({ payload }: { payload: KeyPayload }) {
  try {
    yield call(deleteDump, payload);
    yield put(deleteSuccess(payload));
    yield put(setNotificationSuccess({ title: MessageTitle.crudSuccess }));
  } catch (error: any) {
    const msg = error?.message || 'Failed to delete export';
    yield put(deleteError(msg));
    yield put(setNotificationError({ title: MessageTitle.crudError }));
  }
}

export function* downloadRequestSaga({ payload }: { payload: KeyPayload }) {
  try {
    yield call(downloadDump, payload);
    yield put(downloadSuccess(payload));
    // yield put(setNotificationSuccess({ title: MessageTitle.downloadSuccess }));
  } catch (error: any) {
    const msg = error?.message || 'Failed to download export';
    yield put(downloadError(msg));
    // yield put(setNotificationError({ title: MessageTitle.downloadError}));
  }
}

export function* exportDumpFoldersWatchSaga() {
  yield takeLatest(requestFolders, foldersRequestSaga);
}

export function* exportDumpTriggerWatchSaga() {
  yield takeLatest(requestTrigger, triggerRequestSaga);
}

export function* exportDumpDeleteWatchSaga() {
  yield takeLatest(requestDelete, deleteRequestSaga);
}

export function* exportDumpDownloadWatchSaga() {
  yield takeLatest(requestDownload, downloadRequestSaga);
}

export default function* exportDumpRootSaga() {
  yield* exportDumpFoldersWatchSaga();
  yield* exportDumpTriggerWatchSaga();
  yield* exportDumpDeleteWatchSaga();
  yield* exportDumpDownloadWatchSaga();
}
